// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoBlock_wrapper__BNw1H","videoBlockContainer":"VideoBlock_videoBlockContainer__mhesM"};